import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type Recipient from 'linced-app/models/notifications/recipient';

// Proto: notifications.NotificationParams.
export default class Params extends Fragment {
  declare [Type]: 'notifications/params';

  @attr('string', { defaultValue: '' })
  declare subject: string;

  @attr('string', { defaultValue: '' })
  declare message: string;

  @attr('string', { defaultValue: '' })
  declare content: string;

  @fragmentArray('notifications/recipient')
  declare recipients: FragmentArray<Recipient>;
}
